"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import app components
const breakpoints_1 = __importDefault(require("../breakpoints"));
const container = {
    MuiContainer: {
        styleOverrides: {
            root: {},
            maxWidthMd: {
                [breakpoints_1.default.up("xl")]: {
                    maxWidth: breakpoints_1.default.values.lg,
                },
            },
        },
    },
};
exports.default = container;
